import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { IonicStorageModule } from "@ionic/storage";

import { AppComponent } from './app.component';
// import { ComponentsModule } from '../components/components.module';
import { LangPageModule } from '../pages/lang/lang.module';
import { InfoPageModule } from '../pages/info/info.module';
import { HomePageModule } from '../pages/home/home.module';
import { EnregistrerPageModule } from '../pages/enregistrer/enregistrer.module';
import { MedicamentsPageModule } from '../pages/medicaments/medicaments.module';
import { StatistiquesPageModule } from '../pages/statistiques/statistiques.module';
import { JournalPageModule } from '../pages/journal/journal.module';
import { EcrirePageModule } from '../pages/ecrire/ecrire.module';
import { ConseilsPageModule } from '../pages/conseils/conseils.module';
import { MalPageModule } from '../pages/mal/mal.module';
import { DirectivesModule } from '../directives/directives.module';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    HttpModule,
    IonicModule.forRoot(AppComponent,{
      mode: 'md'
    }),
    IonicStorageModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    LangPageModule,
    DirectivesModule,
    InfoPageModule,
    EnregistrerPageModule,
    MedicamentsPageModule,
    StatistiquesPageModule,
    JournalPageModule,
    EcrirePageModule,
    ConseilsPageModule,
    MalPageModule,
    HomePageModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    AppComponent,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts